import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { http, DEFAULT_SETTINGS } from "./api";

const Ctx = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await http.get("/settings")).data,
    retry: 1,
  });
  return <Ctx.Provider value={{ ...DEFAULT_SETTINGS, ...(data || {}) }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
